// extracted by mini-css-extract-plugin
export var externalLinkIcon = "_sk-5";
export var filledCircle = "_sk-4";
export var historyEntry = "_sk-3";
export var messageSideLeft = "_sk-1";
export var messageSideRight = "_sk-2";
export var orderTrackingCarouselWrapper = "_sk-6";
export var orderTrackingInfoContainer = "_sk-0";